<template>
  <div :class="['property-default-wrapper', property1, className]">
    <div class="frame-35">
      <img
        class="heart-handshake"
        alt="Heart handshake"
        :src="heartHandshake"
      />
      <div class="frame-36">
        <div class="text-wrapper-18">Opérations simplifiées</div>
        <p class="text-wrapper-19">
          Automatisez les tâches répétitives et concentrez-vous sur ce que
          vous aimez le plus : créer de magnifiques arrangements.
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "PropertyDefaultWrapper",
  props: {
    property1: {
      type: String,
      required: true,
    },
    className: {
      type: String,
      default: "",
    },
    heartHandshake: {
      type: String,
      default: "https://c.animaapp.com/nNxA75tB/img/heart-handshake-1.svg",
    },
  },
});
</script>

<style>
.property-default-wrapper {
  align-items: center;
  background-color: #d2f1ba;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: auto;
  justify-content: center;
  left: unset;
  max-width: none;
  min-height: 212px;
  padding: 30px;
  position: relative;
  width: 100%;
}

.property-default-wrapper .frame-35 {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 22px;
  position: relative;
  width: 100%;
}

.property-default-wrapper .heart-handshake {
  height: 32px;
  position: relative;
  width: 32px;
}

.property-default-wrapper .frame-36 {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 10px;
  position: relative;
  width: 100%;
}

.property-default-wrapper .text-wrapper-18 {
  align-self: stretch;
  color: #1a1a1a;
  font-family: "Montserrat", Helvetica;
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 28px;
  margin-top: -1.00px;
  position: relative;
}

.property-default-wrapper .text-wrapper-19 {
  align-self: stretch;
  color: #313131;
  font-family: "Open Sans", Helvetica;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 20px;
  position: relative;
  text-align: center;
}

.property-default-wrapper.default {
  border: 0px none;
  box-shadow: 0px 0px 0px transparent, 0px 1px 2px #0000000d;
  top: unset;
}

.property-default-wrapper.variant-2 {
  border: 1px solid;
  border-color: #c7e6af;
  box-shadow: 0px 1px 6px #08473440;
  top: unset;
}

@media (max-width: 768px) {
  .property-default-wrapper {
    min-height: 0;
    padding: 20px 16px;
  }
}
</style>
